<template>
</template>

<script>
export default {
    data: function () {
        return {
            page: 1,
            totalPages: 100,
            error: false,
            reviews: [],
        }
    },
    props: [
    ],
    mounted() {
        this.initialiseCarousel();
    },
    updated() {
    },
    created() {
    },
    methods: {
        initialiseCarousel() {
            $('.slider-container').not('.slick-initialized').slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                autoplay: false,
                autoplaySpeed: 6000,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            centerMode: true,
                            centerPadding: '20%',
                            arrows: true,
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            centerMode: true,
                            centerPadding: '20%',
                            arrows: true,
                            slidesToShow: 1
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            centerMode: true,
                            centerPadding: '20%',
                            arrows: true,
                            slidesToShow: 1
                        }
                    }
                ]
            });
        },
    },
}
</script>
